import brands from './brands/actions'
import facebook from './facebook/actions'
import me from './me/actions'
import fragrance from './fragrance/actions'
import fragrances from './fragrances/actions'
import giftSet from './giftSet/actions'
import giftCard from './giftCard/actions'
import cart from './cart/actions'
import modals from './modals/actions'
import review from './review/actions'
import reviews from './reviews/actions'
import products from './products/actions'
import payment from './payment/actions'
import ratedFragrances from './ratedFragrances/actions'
import recommendations from './recommendations/actions'
import requestTokens from './requestTokens/actions'
import queue from './queue/actions'
import router from './router/actions'
import subscription from './subscription/actions'
import tours from './tours/actions'
import search from './search/actions'
import upgradeSubscriptionFlow from './upgradeSubscriptionFlow/actions'
import user from './user/actions'
import ui from './ui/actions'
import google from './google/actions'
import seo from './seo/actions'
import collections from './collections/actions'
import breadcrumbs from './breadcrumbs/actions'
import stories from './stories/actions'
import productSets from './productSets/actions'


export default {
  brands,
  breadcrumbs,
  facebook,
  me,
  fragrance,
  fragrances,
  giftSet,
  giftCard,
  cart,
  payment,
  modals,
  review,
  reviews,
  products,
  queue,
  ratedFragrances,
  recommendations,
  requestTokens,
  router,
  subscription,
  tours,
  search,
  upgradeSubscriptionFlow,
  user,
  ui,
  google,
  seo,
  collections,
  stories,
  productSets,
}
